// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"c501479d","469":"18fffba4","829":"c501479d"}[chunkId] + ".chunk.css";
};